import type { GChoiceProps } from './GChoice';

import { Link, Text } from '@shopify/polaris';

export const ChoiceHelpText = ({ item }: { item: GChoiceProps['item'] }) => {
  return (
    <Text as="p" variant="bodyMd">
      {item.description}
      {item.inlineAction && (
        <Link
          monochrome={true}
          onClick={() => {
            if (item.inlineAction?.onAction) {
              item.inlineAction?.onAction();
            } else {
              window.open(item.inlineAction?.url, item.inlineAction?.target ?? '_blank');
            }
          }}
        >
          {item.inlineAction?.content}
        </Link>
      )}
    </Text>
  );
};
